import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

function DropCap(props) {
  const { class: c, className, children, ...rest } = props

  return (
    <p
      className={buildClassNames({
        class: c,
        className,
      })}
      {...rest}
    >
      {children}
    </p>
  )
}

function buildClassNames({ class: c, className }) {
  return classNames(
    c,
    className,
    styles['a-drop-cap'],
  )
}

export default DropCap
